"use client";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { css } from "@/../styled-system/css";

import PricingCard from "./PricingCard";
import { toast } from "../ui/UseToast";

interface PricingCardGridProps {
  planId?: number;
}

function PricingCardGrid({ planId }: PricingCardGridProps) {
  const router = useRouter();
  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);
    if (query.get("success")) {
      toast({
        title: "Subscription Successful",
        description:
          "Thank you for subscribing! You will recieve an email with your invoice.",
      });
    }
  });

  const handleCheckout = async () => {
    try {
      const response = await fetch("/api/stripe/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      console.log(data);

      if (data.url) {
        router.push(data.url);
      } else {
        toast({
          title: "Error",
          description:
            "Error during checkout. Please try again later or contact support if issues persist.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description:
          "Error during checkout. Please try again later or contact support if issues persist.",
        variant: "destructive",
      });
    }
  };

  const handlePortal = async () => {
    try {
      const response = await fetch("/api/stripe/customer-portal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      console.log(data);

      if (data.url) {
        router.push(data.url);
      } else {
        toast({
          title: "Error",
          description:
            "Error opening cutomer portal. Please try again later or contact support if issues persist.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description:
          "Error opening cutomer portal. Please try again later or contact support if issues persist.",
        variant: "destructive",
      });
    }
  };

  const membershipPlans = [
    {
      price: "Free",
      header: "Starter Tier",
      subhead:
        "Begin your journey towards eliminating Daily Wardrobe Panic by joining our Starter tier. This is the perfect introduction to all our platform has to offer.",
      features: [
        "Standard Recommendations & Platform Fees",
        "Free Shipping on Orders Over $250",
        "Unlimited Random Outfit Inspiration",
        "Base Request Priority* (status lineage & consistency is also a factor)",
      ],
      link: "/",
    },
    {
      price: "$25/mth",
      header: "Premium Tier",
      subhead:
        "Are you ready to take the next step in your journey towards eliminating Daily Wardrobe Panic? Subscribe to our Premium tier for an enhanced personalized experience. ",
      features: [
        "Discount Recommendations & Platform Fees* (savings may vary per item)",
        "Free Shipping on Orders Over $100",
        "Unlimited Random & On-Demand Personalized Outfit Inspiration",
        "Top Request Priority** (status lineage & consistency is also a factor)",
      ],
      link: "/pricing",
      onClick: planId === 1 ? () => handleCheckout() : () => handlePortal(),
    },
  ];
  return (
    <div
      className={css({
        mx: "auto",
        md: { display: "flex", justifyContent: "center", gap: "8" },
      })}
    >
      {membershipPlans.map((plan, index) => (
        <div
          key={index}
          className={css({
            mb: "10",
            md: {
              mb: "0",
              minHeight: "100%",
            },
          })}
        >
          <PricingCard planId={planId} content={plan} />
        </div>
      ))}
    </div>
  );
}

export default PricingCardGrid;
